import React, {Component} from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import HeaderComponent from '../components/layouts/HeaderComponent';
import AuthService from '../services/AuthService';

export default function withAuth(
    websocket,
    AuthComponent,
    viewMode,
    roles,
    permissions,
    logoutFunc,
    label,
    whiteBackgroundStyle = 'default-white-background',
    backUrl,
    hideHeader = false,
    afterRenderComponent,
    setActiveMenu,
    menuName,
    customPadding,
    customProps
) {
    const authService = new AuthService();
    return class AuthWrapped extends Component {
        constructor() {
            super();
            this.state = {
                user: null,
            };
            this.mainRef = React.createRef();
        }
        componentDidMount() {
            if (afterRenderComponent) {
                afterRenderComponent(true);
            }
            if (setActiveMenu) {
                setActiveMenu(menuName);
            }
            if (!authService.loggedIn()) {
                if (!!logoutFunc) {
                    logoutFunc(this.props.location.pathname);
                } else {
                    this.props.history.replace('/login?location=' + this.props.location.pathname);
                }
            } else {
                const userRoles = authService.getRoles();
                const userPermissions = authService.getPermissions();
                const helpdeskRole = authService.getProfile().helpdeskUserRole;
                const bankExternalWorker = helpdeskRole === 'BANK_SGB' || helpdeskRole === 'BANK_BPS';
                const pageForBankEmployees = ['bank-start-page','bank-autoregistration','bank-pre-autoregistration'];
                //const menuNameAvailableForSalesRepresentativeAndRegionalManager = ['start', 'cards', 'card-order-list', 'invoice-list', 'transaction-list', 'reports', 'profile', 'settings'];
                let authorized = false;
                if (bankExternalWorker === false && pageForBankEmployees.includes(menuName)){
                    authorized = false;
                } else if(menuName === 'additional-services' && authService.getProfile().agreementType !== 'CASHLESS'){
                    this.props.history.replace('/403');
                } 
                else if (roles !== undefined) {
                    authorized = roles.some(role => {
                        //if (userRoles.includes(role) && userPermissions.length >0) {
                            if (userRoles.includes(role)) {

                            if (role === 'ROLE_FLEET' && permissions) {
                                return permissions.some(permission => userPermissions.includes(permission));
                            }
                            return true;
                        } else if(bankExternalWorker === true){
                            return true
                        }
                        return false;
                    });
                    // if(helpdeskRole !== undefined){
                    //     if( authorized === true && ((!menuNameAvailableForSalesRepresentativeAndRegionalManager.includes(menuName) && (helpdeskRole === 'REGIONAL_MANAGER' || helpdeskRole === 'SALES_REPRESENTATIVE')) )){
                    //         authorized = false;
                    // }}
                } else {
                    authorized = true;
                }
                if (authorized) {
                    try {
                        const profile = authService.getProfile();
                        this.setState({
                            user: profile,
                            viewMode: viewMode,
                            elementId: this.props.match.params.id,
                            params: this.props.match.params,
                        });
                    } catch (err) {
                        authService.logout();
                        this.props.history.replace('/login');
                    }
                } else {
                    // authService.logout();
                    // this.props.history.replace('/login');
                    this.props.history.replace('/403');
                }
            }
        }

        render() {
            let exceptContainers = this.props.location?.pathname === '/order-new' || this.props.location?.pathname === '/order-card-new' || this.props.location?.pathname.includes("/order-fuel-again") || 
                        this.props.location?.pathname.includes("/order-fuel-template-edit") || this.props.location?.pathname.includes("/order-card-again") || this.props.location?.pathname.includes("/order-card-template") ;
            if (this.state.user) {
                return (
                    <React.Fragment>
                        
                         <div
                            className={`${authService.loggedIn() && !exceptContainers ? `header-white-background-top ${whiteBackgroundStyle}` : ''}`}
                        />
                        <div
                            className={`${authService.loggedIn() && !exceptContainers ? `header-white-background ${whiteBackgroundStyle}` : ''}`}
                            // style={{minHeight: whiteBackgroundHeight}}
                        />
                        <div
                            // ref={(el) => {
                            //     this.mainRef = el;
                            // }}
                            ref={this.mainRef}
                            className={`${
                                authService.loggedIn() && !exceptContainers
                                    ? customPadding
                                        ? `container ${customPadding} ${whiteBackgroundStyle}`
                                        : `container-fluid ${whiteBackgroundStyle}`
                                    : ''
                            }`}
                            style={{position: 'relative'}}
                        >
                            <BreadcrumbsItem icon='account-box' to='/start' className='p-link'>
                                Strona główna
                            </BreadcrumbsItem>
                            {!hideHeader ? (
                                <HeaderComponent websocket={websocket} logout={logoutFunc} label={label} backUrl={backUrl} hideBankWelcome={!!customProps ? customProps.hideBankWelcome : false} hideLogout={!!customProps ? customProps.hideLogout : false}/>
                            ) : null}
                            {/* <BreadcrumbsComponent /> */}
                            <AuthComponent
                                mainRef={this.mainRef}
                                history={this.props.history}
                                currentUser={this.state.user}
                                viewMode={this.state.viewMode}
                                elementId={this.state.elementId}
                                backUrl={backUrl}
                                {...this.state}
                                {...customProps}
                            />
                            {/* <FooterComponent /> */}
                        </div>
                    </React.Fragment>
                );
            } else {
                return null;
            }
        }
    };
}
